import {useQuery} from "@tanstack/react-query";
import {searchUsers} from "../services/FacilityService";

export function useUserSearch(page, size, searchString, businessUnitCode, enabled = true) {
    const {data, isLoading, isError, error} = useQuery({
        queryKey: ["userSearch", page, size, searchString, businessUnitCode],
        queryFn: () => searchUsers(page, size, searchString, businessUnitCode),
        enabled: enabled && !!searchString && searchString.length > 0,
        retry: false,
    });

    return {users: data || [], isLoading, isError, error};
}
